<template>
  <nav id="sidebar" class="sidebar" :class="{ collapsed: isHide }">
    <div class="sidebar-content">
      <a class="sidebar-brand" href="/">
        <b-badge class="versionBadge">{{ versionName }} - {{ env }}</b-badge>
        <br />
        <span class="align-middle">
          Callia Admin
        </span>
      </a>
      <ul class="sidebar-nav">
        <!-- Front AI -->
        <li class="sidebar-item" v-if="isAppInFront">
          <a
            href="#front-ai"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Front AI</span>
          </a>
          <ul
            id="front-ai"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/ai/conversation-summarizer"
                >Conversation Summarizer
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#orders"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <package-icon size="1.5x" class="align-middle"></package-icon>
            <span class="align-middle">Orders</span>
          </a>
          <ul
            id="orders"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/manual-fullfillment"
                >Manual Fulfillment
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/replacement-order-automation"
                >Order Replacement Automation
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/checkout-automation"
                >Checkout Automation
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/bulk-order-link-creator"
                >Bulk Order Link Creator
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/upgrade-automation"
                >Upgrade Automation
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/mass-adjust-tags"
                >Mass Adjust Tags
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/reports/pull-automation"
                >Order Adjustments
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/orders/bulkorder"
                >Bulk Order
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/orders/failedorder"
                >Place Failed Order
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Labels -->
        <li class="sidebar-item">
          <a
            href="#callia-export"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Labels</span>
          </a>
          <ul
            id="callia-export"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/exporter/callia-excel-to-pdf"
                >SK & HX Excel to PDF
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/exporter/large-labels-new"
                >EDM, BC, CG, TR, OT, MTL & MB NEW LABELS LINK
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/exporter/callia-gift-box"
                >Curated Gift Box
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/exporter/callia-word-to-pdf"
                >Word to PDF
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/exporter/export-process-report"
                >Label Processes
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Order Pulls -->
        <li class="sidebar-item">
          <a
            href="#reports"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Order Pulls</span>
          </a>
          <ul
            id="reports"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/reports/pull-schedules"
                >Order Pulls Calendar
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/reports/reports-list"
                >Order Pulls and Reports config
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/reports/schedules-list"
                >Order Pulls Schedules List
              </router-link>
            </li>
            <!-- <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/reports/rules-list"
                >Rules list
              </router-link>
            </li> -->
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/latest-order-pulls"
                >Latest OrderPulls
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/reports/bulk-pre-pulls"
                >Bulk Pre Pulls
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/reports/inventory-forecast"
                >Inventory Forecast Report
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Operation (SMS) -->
        <li class="sidebar-item">
          <a
            href="#unsubscribe"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Operation (SMS)</span>
          </a>
          <ul
            id="unsubscribe"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/unsubscribe/phone"
                >Unsubscribe Phone
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/unsubscribe/email"
                >Unsubscribe Email
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/unsubscribe/customer-list"
                >Edit Customer List
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/sms/history"
                >SMS History
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/delivery-notification/SMS"
                >SMS Template Settings
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/delivery-notification/schedules"
                >Text Schedules
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/mass-sms-hub/onfleet-drivers-today"
                >Onfleet Drivers Today
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Customer -->
        <li class="sidebar-item">
          <a
            href="#manage-account"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Customer Account</span>
          </a>
          <ul
            id="manage-account"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/customer/password-reset"
                >Reset Password
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Callia Rules -->
        <li class="sidebar-item">
          <a
            href="#callia-rules"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Callia Rules</span>
          </a>
          <ul
            id="callia-rules"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/orders/cutoffs"
                >CutOffs
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/orders/cutoff-report"
                >Delivery Cutoff Report
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/rules/dates-closed"
                >Dates Closed
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/rules/dates-available"
                >Dates Available
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#region-list"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <map-icon size="1.5x" class="align-middle"></map-icon>
            <span class="align-middle">Places</span>
          </a>
          <ul
            id="region-list"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/region"
                >Region</router-link
              >
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/zone"
                >Zone</router-link
              >
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/town"
                >Town</router-link
              >
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/postalcode"
                >Postal Code</router-link
              >
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#rates-list"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <shopping-bag-icon
              size="1.5x"
              class="align-middle"
            ></shopping-bag-icon>
            <span class="align-middle">Operation (Zones)</span>
          </a>
          <ul
            id="rates-list"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/zone-delivery-rate"
                >Zone Delivery Rate
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/special-zone-delivery-rate"
                >Special Zone Delivery Rate
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a href="#ops" data-toggle="collapse" class="sidebar-link collapsed">
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Tools</span>
          </a>
          <ul
            id="ops"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/ops/postal-code-query"
                >Do we deliver to
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/orders/delivery-window-query"
                >Query Delivery Window
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/ops/links"
                >Ops Links
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/ops/creds"
                >Ops Credentials
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#products"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <gift-icon size="1.5x" class="align-middle"></gift-icon>
            <span class="align-middle">Products</span>
          </a>
          <ul
            id="products"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/products/product-uploads"
                >Product Uploads
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#giftset-alert"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Giftset Alert</span>
          </a>
          <ul
            id="giftset-alert"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/giftset/template"
                >Giftset Alert Template
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/giftset/alert"
                >Giftset Alert List
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#greets"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Greets</span>
          </a>
          <ul
            id="greets"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/greets/add-greets"
                >Add Greet
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link class="sidebar-link" to="/secure/greets/greet-list"
                >Greet List
              </router-link>
            </li>
          </ul>
        </li>

        <li class="sidebar-item">
          <a
            href="#ecs-services"
            data-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <file-text-icon size="1.5x" class="align-middle"></file-text-icon>
            <span class="align-middle">Dev Corner</span>
          </a>
          <ul
            id="ecs-services"
            class="sidebar-dropdown list-unstyled collapse"
            data-parent="#sidebar"
          >
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/dev-corner/dev-ecs-manage"
                >Dev ECS Manage
              </router-link>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/dev-corner/deploy-maintenance-site"
                >Deploy Maintenance Site
              </router-link>
            </li>
            <li class="sidebar-item">
              <a class="sidebar-link" target="_blank" href="https://tools.calliaops.com/"
                >CalliaOps Tool Publisher
              </a>
            </li>
            <li class="sidebar-item">
              <router-link
                class="sidebar-link"
                to="/secure/exporter/large-labels"
                >EDM, BC, CG, TR, OT, MTL & MB NEW LABELS LINK(Old, Slow)
              </router-link>
            </li>
          </ul>
        </li>

        <!--          <li class="sidebar-item">-->
        <!--            <a-->
        <!--                href="#schedules"-->
        <!--                data-toggle="collapse"-->
        <!--                class="sidebar-link collapsed"-->
        <!--            >-->
        <!--              <truck-icon size="1.5x" class="align-middle"></truck-icon>-->
        <!--              <span class="align-middle">Schedules</span>-->
        <!--            </a>-->
        <!--            <ul-->
        <!--                id="schedules"-->
        <!--                class="sidebar-dropdown list-unstyled collapse"-->
        <!--                data-parent="#sidebar"-->
        <!--            >-->
        <!--              <li class="sidebar-item">-->
        <!--                <router-link class="sidebar-link" to="/secure/schedule/drivers"-->
        <!--                >Drivers-->
        <!--                </router-link-->
        <!--                >-->
        <!-- <a class="sidebar-link" href="#">Drivers</a> -->
        <!--              </li>-->
        <!--              <li class="sidebar-item">-->
        <!--                <a class="sidebar-link" href="#">Couriers</a>-->
        <!--              </li>-->
        <!--            </ul>-->
        <!--          </li>-->
      </ul>
    </div>
  </nav>
</template>
<script>
import {
  PackageIcon,
  FileTextIcon,
  GiftIcon,
  MapIcon,
  ShoppingBagIcon,
  MessageSquareIcon
} from "vue-feather-icons";
import { eventBus } from "../../main";
import Front from "@frontapp/plugin-sdk";

export default {
  data() {
    return {
      isHide: false,
      versionName: process.env.VUE_APP_PROJECT_VERSION,
      env: process.env.VUE_APP_ENV_NAME,
      isAppInFront: false
    };
  },
  components: {
    // TruckIcon,
    PackageIcon,
    FileTextIcon,
    GiftIcon,
    MapIcon,
    ShoppingBagIcon
  },
  created() {
    eventBus.$on("hideLeftMenuEvent", data => {
      this.isHide = data;
    });
    eventBus.$on("toggleLeftMenuEvent", () => {
      this.isHide = !this.isHide;
    });
    try {
      Front.contextUpdates.subscribe(async context => {
        this.isAppInFront = true;
      });
    } catch (e) {
      this.isAppInFront = false;
    }
  },
  methods: {
    closeAllMenus() {
      document.querySelectorAll(".sidebar-dropdown.collapse").forEach(el => {
        el.classList.remove("show");
      });
    }
  },
  watch: {
    $route() {
      this.isHide = true;
      this.closeAllMenus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/sidebar.scss";
</style>
